import type {
  ExpenseKind,
  ExpensePayer,
  ExpenseStatus,
  TimeExpense
} from "../types";

/** Each kind with the UTBMS expense code it exports under. */
export const EXPENSE_KINDS: { id: ExpenseKind; label: string; code: string }[] =
  [
    { id: "filing_fee", label: "Filing fee", code: "E112" },
    { id: "premium_processing", label: "Premium processing", code: "E112" },
    { id: "recruitment_ad", label: "Recruitment ad", code: "E124" },
    { id: "courier", label: "Courier", code: "E107" },
    { id: "translation", label: "Translation", code: "E124" },
    { id: "other", label: "Other", code: "E124" }
  ];

export const PAYER_OPTIONS: { id: ExpensePayer; label: string }[] = [
  { id: "split", label: "Case terms" },
  { id: "employer", label: "Employer" },
  { id: "employee", label: "Employee" }
];

export const EXPENSE_STATUS_LABEL: Record<ExpenseStatus, string> = {
  suggested: "Suggested",
  draft: "Confirmed",
  approved: "Approved",
  exported: "Exported",
  discarded: "Discarded"
};

/** Who pays, on a case with a company; empty otherwise. */
export const payerText = (x: Pick<TimeExpense, "employer_pct">): string => {
  if (x.employer_pct === null || x.employer_pct === undefined) return "";
  if (x.employer_pct >= 100) return "Employer";
  if (x.employer_pct <= 0) return "Employee";
  return `Employer ${Math.round(x.employer_pct)}%`;
};

export const originText = (x: Pick<TimeExpense, "origin">): string => {
  if (x.origin === "receipt") return "From the filed receipt notice";
  if (x.origin === "assistant") return "Suggested by the assistant";
  return "";
};

/** "$1,234.50" or "1234.5" as dollars; null when it isn't a positive amount. */
export const parseAmount = (text: string): number | null => {
  const n = Number(text.replace(/[$,\s]/g, ""));
  return text.trim() && Number.isFinite(n) && n > 0
    ? Math.round(n * 100) / 100
    : null;
};

/** What counts toward the case's costs: confirmed and later, not suggestions. */
export const expenseTotal = (rows: TimeExpense[]): number =>
  rows
    .filter((x) => x.status !== "suggested" && x.status !== "discarded")
    .reduce((sum, x) => sum + x.amount, 0);

export const canEditExpense = (
  x: Pick<TimeExpense, "status">,
  isAdmin: boolean
): boolean =>
  x.status === "exported" || x.status === "discarded"
    ? false
    : x.status !== "approved" || isAdmin;
